(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dermamimo-anuncios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dermamimo-duration')) {
    customElements.define(
      'dermamimo-duration',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.start());
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          clearInterval(this.interval);
        }

        start() {
          clearInterval(this.interval);

          const hours = Math.min(
            48,
            Math.max(1, Number(this.dataset.hours) || 10)
          );

          const duration = hours * 3600000;

          const key = 'dermamimo:duration:' + JSON.stringify([
            this.dataset.section,
            this.dataset.campaign,
            hours
          ]);

          this.end = Date.now() + duration;

          if (this.dataset.editor !== 'true') {
            try {
              const stored = Number(localStorage.getItem(key));

              if (
                Number.isFinite(stored) &&
                stored > 0 &&
                stored <= this.end
              ) {
                this.end = stored;
              } else {
                localStorage.setItem(key, String(this.end));
              }
            } catch (error) {
              // Si el almacenamiento está bloqueado,
              // el contador funciona durante esta visita.
            }
          }

          this.clock = this.querySelector('[data-clock]');
          this.finished = this.querySelector('[data-finished]');
          this.copies = this.querySelectorAll('[data-copy]');
          this.h = this.querySelector('[data-h]');
          this.m = this.querySelector('[data-m]');
          this.s = this.querySelector('[data-s]');

          this.hidden = false;
          this.finished.hidden = true;

          this.copies.forEach(copy => {
            copy.hidden = false;
          });

          if (this.tick()) {
            this.interval = setInterval(() => this.tick(), 1000);
          }
        }

        tick() {
          const left = Math.max(
            0,
            Math.ceil((this.end - Date.now()) / 1000)
          );

          if (!left) {
            clearInterval(this.interval);
            this.clock.hidden = true;

            this.copies.forEach(copy => {
              copy.hidden = true;
            });

            if (
              this.dataset.expiry === 'hide' &&
              this.dataset.editor !== 'true'
            ) {
              this.hidden = true;
            } else {
              this.finished.hidden = false;
            }

            return false;
          }

          this.clock.hidden = false;

          this.h.textContent = String(
            Math.floor(left / 3600)
          ).padStart(2, '0');

          this.m.textContent = String(
            Math.floor(left / 60) % 60
          ).padStart(2, '0');

          this.s.textContent = String(
            left % 60
          ).padStart(2, '0');

          return true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermamimo-encabezado"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    document
      .querySelectorAll('details[data-dm-header-menu][open]')
      .forEach(menu => {
        if (
          !menu.contains(event.target) ||
          event.target.closest('a')
        ) {
          menu.open = false;
        }
      });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('details[data-dm-header-menu][open]')
      .forEach(menu => {
        const restoreFocus = menu.contains(document.activeElement);

        menu.open = false;

        if (restoreFocus) {
          menu.querySelector('summary').focus();
        }
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermamimo-packs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dm-pack-selector')) {
  customElements.define('dm-pack-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('.dm-pack-buy');
      this.error = this.querySelector('.dm-pack-error');
      this.field = this.querySelector('[data-variant-id]');
      this.planField = this.querySelector('[data-selling-plan]');
      this.label = this.querySelector('[data-button-text]');
      this.originalLabel = this.label.textContent.trim();
      this.subscription = this.querySelector('[data-subscription]');
      this.toggle = this.querySelector('[data-subscribe]');
      this.planSelect = this.querySelector('[data-plan-select]');
      this.cards = Array.from(this.querySelectorAll('[data-card]'));
      this.form.addEventListener('change', event => {
        const card = event.target.closest('[data-card]');
        if (card && event.target.matches('[data-variant]')) {
          const radio = card.querySelector('input[type=radio]');
          if (!radio.disabled) radio.checked = true;
        }
        this.refresh();
      });
      this.form.addEventListener('submit', event => this.addPack(event));
      if (this.toggle) this.toggle.checked = false;
      const initial = this.querySelector('[data-preferred="true"] input[type=radio]:not(:disabled)') || this.querySelector('input[type=radio]:not(:disabled)');
      if (initial) initial.checked = true;
      this.refresh();
    }

    plans(option) {
      try {
        const plans = JSON.parse(option?.dataset.plans || '[]');
        return Array.isArray(plans) ? plans.filter(p => p.id && typeof p.price === 'string') : [];
      } catch { return []; }
    }

    refresh() {
      const entries = this.cards.map(card => ({
        card,
        radio: card.querySelector('input[type=radio]'),
        option: card.querySelector('[data-variant]')?.selectedOptions[0]
      }));
      let planId = '';
      if (this.toggle) {
        const sets = entries.map(entry => this.plans(entry.option));
        const common = sets.length ? sets[0].filter(plan => sets.every(set => set.some(p => p.id === plan.id))) : [];
        const previous = this.planSelect.value;
        this.planSelect.replaceChildren();
        common.forEach(plan => this.planSelect.add(new Option(plan.name, plan.id)));
        if (common.some(plan => plan.id === previous)) this.planSelect.value = previous;
        const hasPlans = common.length > 0;
        const singlePlan = common.length === 1;
        this.planSelect.hidden = singlePlan;
        this.querySelector('[data-plan-label]').hidden = singlePlan;
        this.querySelector('[data-plan-caption]').hidden = !singlePlan;
        this.subscription.hidden = !hasPlans;
        const setup = this.querySelector('[data-sub-setup]');
        if (setup) setup.hidden = hasPlans;
        if (!hasPlans) this.toggle.checked = false;
        if (hasPlans) {
          const selectedId = this.planSelect.value;
          const discount = Math.min(...sets.map(set => Number(set.find(p => p.id === selectedId).extra)));
          const title = this.querySelector('[data-sub-title]');
          title.textContent = title.dataset.template.replaceAll('{discount}', String(discount));
          this.querySelector('[data-plan-discount]').textContent = String(discount);
          if (this.toggle.checked) planId = selectedId;
        }
        this.subscription.classList.toggle('is-active', Boolean(planId));
        this.querySelector('[data-sub-options]').hidden = !planId;
        this.toggle.disabled = Boolean(this.busy);
        this.planSelect.disabled = Boolean(this.busy);
      }

      let id = '';
      let chosenPlan = null;
      entries.forEach(({card, radio, option}) => {
        const plan = planId ? this.plans(option).find(p => p.id === planId) : null;
        const active = radio.checked && !radio.disabled && option && !option.disabled && (!planId || plan);
        card.classList.toggle('is-selected', Boolean(active));
        if (option) {
          const data = plan || option.dataset;
          card.querySelector('[data-price]').textContent = data.price;
          for (const key of ['compare', 'saving']) {
            const target = card.querySelector(`[data-${key}]`);
            target.textContent = data[key] || '';
            target.hidden = !data[key];
          }
          const recurring = card.querySelector('[data-recurring]');
          recurring.hidden = !plan;
          recurring.textContent = plan ? 'por entrega' : '';
        }
        if (active) { id = option.value; chosenPlan = plan; }
      });
      this.field.value = id;
      this.field.disabled = !id;
      this.planField.value = id && chosenPlan ? chosenPlan.id : '';
      this.planField.disabled = !this.planField.value;
      this.button.disabled = Boolean(this.busy || !id);
      if (!this.busy) this.label.textContent = planId ? 'Agregar pack con suscripción' : this.originalLabel;
      if (this.toggle) {
        const summary = this.querySelector('[data-sub-summary]');
        summary.textContent = chosenPlan ? `${chosenPlan.name}. ${chosenPlan.price} por entrega del pack seleccionado. Se repetirá el pack completo; envío e impuestos se calculan al pagar.` : '';
      }
    }

    async addPack(event) {
      event.preventDefault();
      if (this.busy) return;
      this.refresh();
      if (!this.field.value) return;
      const item = { id: this.field.value, quantity: 1 };
      if (!this.planField.disabled && this.planField.value) item.selling_plan = this.planField.value;
      this.busy = true;
      this.refresh();
      this.form.querySelector('fieldset').disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.label.textContent = 'Agregando…';
      this.error.hidden = true;
      try {
        const response = await fetch(this.dataset.add, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'No se pudo agregar el pack. Revisa su disponibilidad.');
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.error.textContent = error instanceof TypeError ? 'No pudimos confirmar la operación. Revisa tu carrito antes de intentarlo de nuevo.' : error.message;
        this.error.hidden = false;
        this.busy = false;
        this.form.querySelector('fieldset').disabled = false;
        this.form.removeAttribute('aria-busy');
        this.refresh();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dermamimo-resenas-galeria"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dermamimo-reviews')) {
  customElements.define('dermamimo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('[data-review-dialog]');
      this.content = this.querySelector('[data-review-content]');
      this.templates = [...this.querySelectorAll('[data-review-template]')];
      this.zoomButton = this.querySelector('[data-review-zoom]');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.cards.sort((a,b) => Number(Boolean(b.querySelector('.dr-photo-button img'))) - Number(Boolean(a.querySelector('.dr-photo-button img'))));
      const grid = this.querySelector('.dr-grid');
      this.cards.forEach(card => grid.append(card));
      this.templates = this.cards.map(card => card.querySelector('[data-review-template]'));
      this.cards.forEach((card, index) => {
        const body = card.querySelector('.dr-readable');
        if (!body || body.textContent.trim().length <= 220 || card.querySelector('[data-text-toggle]')) return;
        body.id = this.id + '-excerpt-' + index;
        body.classList.add('is-collapsed');
        const toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'dr-text-toggle';
        toggle.setAttribute('data-text-toggle', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-controls', body.id);
        toggle.textContent = 'Leer más';
        body.after(toggle);
      });
      this.limit = Math.max(2, Math.ceil((Number(this.dataset.initialCount) || 6) / 2) * 2);
      this.expandButton = this.querySelector('[data-review-expand]');
      this.setExpanded(false);
      this.addEventListener('shopify:block:select', () => this.setExpanded(true), options);
      const hideFailedPhoto = event => {
        const wrapper = event.target.closest?.('.dr-extra-photo');
        if (wrapper) { wrapper.hidden = true; if (this.content.contains(wrapper)) this.zoomButton.hidden = true; }
      };
      this.addEventListener('error', hideFailedPhoto, {capture:true, signal:this.controller.signal});
      this.querySelectorAll('.dr-extra-photo img').forEach(img => {if (img.complete && img.naturalWidth === 0) hideFailedPhoto({target:img});});
      this.addEventListener('keydown', event => {
        if (event.target.matches('.dr-open[role="group"]') && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          event.target.click();
        }
      }, options);
      this.addEventListener('click', event => {
        const textToggle = event.target.closest('[data-text-toggle]');
        if (textToggle) {
          const body = textToggle.closest('[data-review-card]').querySelector('.dr-readable');
          const expanded = textToggle.getAttribute('aria-expanded') !== 'true';
          body.classList.toggle('is-collapsed', !expanded);
          textToggle.setAttribute('aria-expanded', String(expanded));
          textToggle.textContent = expanded ? 'Leer menos' : 'Leer más';
          return;
        }
        if (event.target.closest('[data-review-expand]')) {
          this.setExpanded(!this.expanded);
          if (!this.expanded) this.expandButton.scrollIntoView({block:'center', behavior:'smooth'});
          return;
        }
        const opener = event.target.closest('[data-open-review]');
        if (opener) { this.opener = opener; this.showReview(this.templates.indexOf(opener.closest('[data-review-card]').querySelector('[data-review-template]'))); this.dialog.showModal(); return; }
        if (event.target.closest('[data-review-close]')) this.dialog.close();
        if (event.target.closest('[data-review-prev]')) this.showReview(this.index - 1);
        if (event.target.closest('[data-review-next]')) this.showReview(this.index + 1);
        if (event.target.closest('[data-review-zoom]')) {
          const media = this.content.querySelector('.dr-media');
          if (!media) return;
          const zoomed = media.classList.toggle('is-zoomed');
          this.zoomButton.setAttribute('aria-pressed', String(zoomed));
          this.zoomButton.textContent = zoomed ? this.dataset.zoomOutLabel : this.dataset.zoomLabel;
        }
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => { if (this.opener?.isConnected) this.opener.focus(); }, options);
      this.dialog.addEventListener('keydown', event => {
        if (event.target.closest('input,textarea,select')) return;
        if (this.content.querySelector('.is-zoomed')) return;
        if (event.key === 'ArrowRight') { event.preventDefault(); this.showReview(this.index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.showReview(this.index - 1); }
      }, options);
    }
    setExpanded(expanded) {
      this.expanded = expanded;
      const visibleCount = expanded ? this.cards.length : Math.min(this.limit, this.cards.length);
      this.cards.forEach((card, index) => {
        card.hidden = index >= visibleCount;
        card.classList.toggle('dr-fill-row', visibleCount % 2 === 1 && index === visibleCount - 1);
      });
      if (!this.expandButton) return;
      this.expandButton.hidden = this.cards.length <= this.limit;
      this.expandButton.setAttribute('aria-expanded', String(expanded));
      this.expandButton.textContent = expanded ? (this.dataset.collapseLabel || 'Ver menos reseñas') : (this.dataset.expandLabel || 'Ver todas las reseñas');
      const count = this.querySelector('[data-visible-count]');
      if (count) count.textContent = this.cards.length ? `${expanded ? this.cards.length : Math.min(this.limit,this.cards.length)} de ${this.cards.length} reseñas` : '';
    }
    showReview(index) {
      if (!this.templates.length) return;
      this.index = (index + this.templates.length) % this.templates.length;
      this.content.replaceChildren(this.templates[this.index].content.cloneNode(true));
      const title = this.content.querySelector('[data-modal-title]');
      title.id = this.id + '-modal-title';
      this.dialog.setAttribute('aria-labelledby', title.id);
      this.querySelector('[data-review-counter]').textContent = `${this.index + 1} / ${this.templates.length}`;
      this.querySelector('[data-review-prev]').disabled = this.templates.length < 2;
      this.querySelector('[data-review-next]').disabled = this.templates.length < 2;
      this.zoomButton.hidden = !this.content.querySelector('.dr-media');
      this.zoomButton.setAttribute('aria-pressed', 'false');
      this.zoomButton.textContent = this.dataset.zoomLabel;
      this.dialog.scrollTop = 0;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
